import sectorsReducer from "./reducers";
export { default as sectorsTypes } from "./types";
export { default as sectorsOperations } from "./operations";
export default sectorsReducer;
